import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-worker-page',
  templateUrl: './worker-page.component.html',
  styleUrls: ['./worker-page.component.scss']
})
export class WorkerPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
